import React from 'react';
import cx from 'classnames';

interface Props {
  tailwindColor?: string;
  className?: string;
}

const ClockIcon: React.FC<Props> = ({ tailwindColor = `flgray-900`, className }) => (
  <svg
    className={cx(className, `inline-block`)}
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path
      className={cx(`text-${tailwindColor}`, `fill-current`)}
      d="M9,0 C4.0361087,0 0,4.0361087 0,9 C0,13.9638913 4.0361087,18 9,18 C13.9638913,18 18,13.9638913 18,9 C18,4.0361087 13.9638913,0 9,0 Z M9,1.17391304 C13.3288043,1.17391304 16.826087,4.67119565 16.826087,9 C16.826087,13.3288043 13.3288043,16.826087 9,16.826087 C4.67119565,16.826087 1.17391304,13.3288043 1.17391304,9 C1.17391304,4.67119565 4.67119565,1.17391304 9,1.17391304 Z M9,2.54347826 C8.67596087,2.54347826 8.41304348,2.80639565 8.41304348,3.13043478 L8.41304348,9 C8.41304348,9.32403913 8.67596087,9.58695652 9,9.58695652 L14.4782609,9.58695652 C14.8023,9.58695652 15.0652174,9.32403913 15.0652174,9 C15.0652174,8.67596087 14.8023,8.41304348 14.4782609,8.41304348 L9.58695652,8.41304348 L9.58695652,3.13043478 C9.58695652,2.80639565 9.32403913,2.54347826 9,2.54347826 Z"
    />
  </svg>
);

export default ClockIcon;
